import {AbstractFilter} from './AbstractFilter';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class DoubleBonusFilter extends AbstractFilter {
    protected bonus: number;
    protected scatterIndexFromMath: number;

    constructor(name: string, bonus: number, scatterIndexFromMath: number) {
        super(name);
        this.bonus = bonus;
        this.scatterIndexFromMath = scatterIndexFromMath;
    }

    public filter(response: Message, session: Session): boolean {
        if (response.getAction() === Action.FREESPIN || response.getAction() === Action.SPIN) {
            const spin = this.getSpin(response);
            let scatterCount = 0;

            for (const symbolId of spin.symbolIds) {
                for (const symbol of symbolId) {
                    if (symbol === this.scatterIndexFromMath) {
                        scatterCount++;
                    }
                }
            }

            if (scatterCount >= 3 && session.getBonus(this.bonus)) {
                return true;
            }
        } else if (response.getAction() !== Action.FREESPIN && response.getAction() !== Action.SPIN) {
            return true;
        }

        return false;
    }
}
